import React from 'react';
import { useTranslation } from '@lt/localization';
import styled from 'styled-components';

const BestPriceTooltip = ({ isMobile }: { isMobile: boolean }) => {
  const { t } = useTranslation();
  return (
    <StyledTooltipContainer $isMobile={isMobile}>
      <StyledBestPriceHeader $isMobile={isMobile} className="like-h3">
        {t('checkout.bestPrice.title')}
      </StyledBestPriceHeader>
      <StyledParagraph>{t('checkout.bestPrice.description')}</StyledParagraph>
      <StyledLink
        href="/packages/best_price_guarantee.pdf"
        title={t('checkout.bestPrice.detailButton')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('checkout.bestPrice.detailButton')}
      </StyledLink>
      {!isMobile && <button type="button" className="react-hint__close" />}
    </StyledTooltipContainer>
  );
};
const StyledTooltipContainer = styled.div<{ $isMobile: boolean }>`
  font-size: 14px;
  font-weight: normal;
  text-transform: none;
  color: #4d4d4d;
  ${({ $isMobile }) =>
    !$isMobile &&
    `
      padding: 8px 15px;
      font-size: 14px;
      white-space: pre-line;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 20px 0 rgba(191, 191, 172, 0.5);
  `}
  ${({ $isMobile }) =>
    $isMobile &&
    `    
      white-space: normal;
      margin-top: 8px;
  `}
`;
const StyledParagraph = styled.p`
  padding-top: 8px;
  padding-bottom: 8px;
  min-width: 325px;
`;
const StyledLink = styled.a`
  padding-top: 8px;
  font-weight: bold;
  text-decoration: none;
  color: #007aff !important;

  &:hover {
    color: #2080f1 !important;
  }
`;
const StyledBestPriceHeader = styled.h3<{ $isMobile: boolean }>`
  ${({ $isMobile }) => !$isMobile && `white-space: pre-line;`}
`;

export default BestPriceTooltip;
